class PolicyDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.setEventListeners();

  }

  setEventListeners() {
    const openTokens = document.querySelectorAll('.policy-link'),
          closeTokens = this.querySelectorAll('.policy-close');
    
    openTokens.forEach((token) => {

      token.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    closeTokens.forEach((token) => {
      token.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    this.classList.add('opened');
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('active')}, 50);
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    setTimeout(() => {
      this.classList.remove('opened');
    }, 120);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('policy-drawer', PolicyDrawer);
